import { render, staticRenderFns } from "./PerimeterQuestion.vue?vue&type=template&id=237c7b7a&"
import script from "./PerimeterQuestion.vue?vue&type=script&lang=js&"
export * from "./PerimeterQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PerimeterQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports